(function () {
  function setExpanded(item, expanded) {
    item.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    setExpanded(item, false);
  }

  function openItem(item) {
    item.classList.add('is-open');
    setExpanded(item, true);
  }

  function toggleItem(section, item) {
    var isOpen = item.classList.contains('is-open');
    var allowMultiple = section.dataset.faqAllowMultiple === 'true';

    if (!allowMultiple && !isOpen) {
      section.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
        if (openItem !== item) closeItem(openItem);
      });
    }

    if (isOpen) {
      closeItem(item);
    } else {
      openItem(item);
    }
  }

  function initFaq(section) {
    if (section.dataset.faqBound) return;
    section.dataset.faqBound = 'true';

    section.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-faq-item]');
        if (item) toggleItem(section, item);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-faq-section]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-faq-section]');
    if (section) {
      delete section.dataset.faqBound;
      initFaq(section);
    }
  });
})();
